import { gql } from '@apollo/client'

export const GET_USER_INVOICE_URL = gql`
    query get_user_invoice_url($booking_id: String!) {
        get_user_invoice_url(booking_id: $booking_id) {
            signed_url
        }
    }
`
